<div class="pb-6 bg-grey-200 page-padding-y">
  <ng-container *ngIf="srsBallotDetail && !loading">
    <span
      class="flex items-center justify-between mb-6 break-words page-padding-x"
    >
      <h5 class="text-darkBlue-500"  id="h5-SRS-designation">{{ srsBallotDetail?.designation }}</h5>
      <app-header-ballot-type ballotType="SR" id="header-ballot-type"></app-header-ballot-type>
    </span>
    <div class="flex flex-col gap-2 page-padding-x 2xl:flex-row 2xl:gap-0">
      <h5
        class="flex flex-wrap justify-start w-full gap-2 break-words place-items-start"
        id="h5-SRS-designation-title"
      >
        {{ srsBallotDetail?.designationTitle }}
      </h5>

      <div class="float-right">
        <app-vote-legend ballotType="SRS"></app-vote-legend>
      </div>

    </div>
  </ng-container>
</div>

<div class="flex-1 pt-6 bg-grey-100 page-padding-x page-padding-b">
  
  <ng-container>
    <app-tab
      #appTab
      [tabs]="visibleTabs"
      id="ballotDetailsTab"
      [initialTabId]="initialTabId"
      (onTabChange)="onTabChange($event)"
    >
    </app-tab>
    <ng-container *ngIf="srsBallotDetail">
      <div *ngIf="!loading" [class.hidden]="selectedTab !== 'ballotSummary'">
        <app-srs-summary
          [srsBallotDetail]="srsBallotDetail"
          (onPlaceVote)="refreshSRSBallot($event)"
          (afterSave)="refreshSRSBallot($event)"
        ></app-srs-summary>
      </div>
      <div *ngIf="!loading" [class.hidden]="selectedTab !== 'viewVotes'">
        <app-srs-votes
          [srsBallotDetail]="srsBallotDetail"
          (afterSave)="refreshSRSBallot($event)"
        ></app-srs-votes>
      </div>
      <div *ngIf="!loading && isInternalUser" [class.hidden]="selectedTab !== 'internalHistory'">
        <app-ballot-history
          id="srsBallotHistory"
          [ballotHistoryItems]="srsBallotDetail?.ballotHistory || []"
        ></app-ballot-history>
      </div>
    </ng-container>

    <ng-container *ngIf="!srsBallotDetail && !loading">
      <div class="flex items-center justify-center h-full">
        <p>Unable to get ballot details</p>
      </div>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="loading">
    <div class="flex items-center justify-center h-full">
      <app-loading-indicator [size]="32"></app-loading-indicator>
    </div>
  </ng-container>
</div>
